export const logo = {
  name: "logo",
  viewBox: "0 0 41.37 38.3",
  elements: [
    {
      type: "circle",
      data: {
        cx: "19.02",
        cy: "19.28",
        r: "6.22",
      },
    },
    {
      type: "path",
      data: {
        d: "M32.37 16.44a14 14 0 0 1 .3 2.84A13.63 13.63 0 1 1 24.87 7V1.18a19 19 0 1 0 13 15.26z",
      },
    },
    {
      type: "path",
      data: {
        d: "M41.37 2.4l-1.54 1.53-4.45 4.45-.7.71c-.12.12-.08.22.09.22h3.36v3.39h-9.62V3.08h3.39v3.67c0 .18.1.22.23.09l1-1L39 0z",
      },
    },
  ],
};
export const manualIcon = {
  name: "manual",
  viewBox: "0 0 320 512",
  elements: [
    {
      type: "path",
      data: {
        d: "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v9.3c0 19.6-9 38.2-24.5 50.3l-75.3 59.2L128 288.4V304v48h64V319.6L255.1 270C286 245.7 304 208.6 304 169.3V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160v16H80V160zM200 400H120v80h80V400z",
      },
    },
  ],
};
export const userIcon = {
  name: "user",
  viewBox: "0 0 28.13 35.14",
  elements: [
    {
      type: "path",
      data: {
        d: "M15.23 0l1 .23a6.5 6.5 0 0 1 5.33 5.9 14.17 14.17 0 0 1-2.12 9.65A6.27 6.27 0 0 1 11.19 18a7.11 7.11 0 0 1-2.5-2.28 14 14 0 0 1-2-10.36 6.47 6.47 0 0 1 5.7-5.21 3.63 3.63 0 0 0 .54-.15z",
      },
    },
    {
      type: "path",
      data: {
        d: "M28.05 30.4c-.33-2.49-.69-5-1.2-7.42a5 5 0 0 0-3.76-3.93c-1-.29-2-.71-3.05-1.1a7.85 7.85 0 0 1-6 2.57 7.85 7.85 0 0 1-6-2.57c-1.06.39-2 .81-3 1.1A5 5 0 0 0 1.28 23c-.51 2.43-.87 4.91-1.2 7.4-.24 1.77 0 2 1.69 2.62a41.87 41.87 0 0 0 11.14 2.1H15.22A41.87 41.87 0 0 0 26.36 33c1.7-.56 1.93-.83 1.69-2.6z",
      },
    },
  ],
};

export const newUserIcon = {
  name: "newUser",
  viewBox: "0 0 22 24.95",
  elements: [
    {
      type: "path",
      data: {
        d: "M10.28 0l.72.16a4.37 4.37 0 0 1 3.6 4 9.59 9.59 0 0 1-1.43 6.51 4.23 4.23 0 0 1-5.58 1.52 4.55 4.55 0 0 1-1.69-1.54 9.41 9.41 0 0 1-1.35-7A4.36 4.36 0 0 1 8.36.1a2.24 2.24 0 0 0 .37-.1z",
      },
    },
    {
      type: "path",
      data: {
        d: "M17.37 14.06a6.14 6.14 0 0 0-5.18 9.55c-1.2 0-2.35.16-3.48.1a28.4 28.4 0 0 1-7.52-1.42c-1.14-.39-1.3-.57-1.14-1.77.23-1.67.47-3.35.82-5a3.35 3.35 0 0 1 2.53-2.66c.69-.19 1.35-.48 2.06-.74a5.35 5.35 0 0 0 4.11 1.74 5.22 5.22 0 0 0 3.7-1.48.53.53 0 0 1 .7-.13c.69.31 1.42.51 2.1.82a14.81 14.81 0 0 1 1.39.81z",
      },
    },
    {
      type: "path",
      data: {
        d: "M21.91 19.18a4.82 4.82 0 1 0-8.16 4.33A5.77 5.77 0 0 0 16.49 25h1.33a1.86 1.86 0 0 1 .25-.1 4.81 4.81 0 0 0 3.84-5.72zM19.14 21H18v1.18a.85.85 0 0 1-.88.92c-.48 0-.77-.37-.78-.94V21.1l-.07-.1h-1.1c-.57 0-.91-.31-.92-.81s.33-.84.93-.85h1.18v-1.17a.83.83 0 0 1 .8-.93.86.86 0 0 1 .86.9v1.2h1.09c.62 0 1 .34 1 .85s-.37.81-.97.81z",
      },
    },
  ],
};

export const enterpriseIcon = {
  name: "enterprise",
  viewBox: "0 0 43.45 35.14",
  elements: [
    {
      type: "path",
      data: {
        d: "M11.74 35.14h7.67v-6.57H24v6.57h7.7V0h-20zm2.48-32.52h6.6v6.6h-6.6zm8.4 0h6.6v6.6h-6.6zM14.22 11h6.6v6.6h-6.6zm8.4 0h6.6v6.6h-6.6zm-8.4 8.4h6.6V26h-6.6zm8.4 0h6.6V26h-6.6zm-6.91-1M33.5 3.15V28h3v7.14h7v-32zm2 2.35h6v6h-6zm0 7.28h6v6h-6zm0 7.28h6v6h-6zM-.09 3.15v32h7V28h3V3.15zm8 8.33h-6v-6h6zm0 7.28h-6v-6h6zm0 7.27h-6v-6h6z",
      },
    },
  ],
};

export const icons = [
  // {
  //   name: "dashboard",
  //   viewBox: "0 0 22 21.72",
  //   elements: [
  //     {
  //       type: "path",
  //       data: {
  //         d:
  //           "M0 14.99h9.42v6.73H0zM12.58 0H22v6.73h-9.42zM12.58 9.94v11.78H22V9.94zM20.7 20.5h-6.82v-9.34h6.82zM0 0v11.78h9.42V0zm8.12 10.56H1.3V1.22h6.82z"
  //       }
  //     }
  //   ]
  // },
  {
    name: "tests",
    viewBox: "0 0 22 27.25",
    elements: [
      {
        type: "path",
        data: {
          d: "M6.4 5h9.27a.7.7 0 0 0 .77-.76V2.6a.7.7 0 0 0-.75-.76h-1a.4.4 0 0 1-.43-.26c-.21-.4-.46-.78-.67-1.18A.69.69 0 0 0 13 0H9.52c-1.14 0-1-.17-1.52.9a1.41 1.41 0 0 1-1.63 1c-.52-.07-.8.27-.8.79v1.46c-.01.6.24.85.83.85z",
        },
      },
      {
        type: "path",
        data: {
          d: "M22 5.22a2.55 2.55 0 0 0-2.65-2.63h-2.14v1.55c0 .06.16.16.25.16h1.85c.61 0 .95.24.95.94v19.34c0 .71-.25 1-1 1H2.7c-.72 0-1-.25-1-1V5.25c0-.7.24-.94 1-.94h1.85c.09 0 .25-.1.25-.16V2.6H2.66A2.55 2.55 0 0 0 0 5.22v19.54a2.47 2.47 0 0 0 2.5 2.49h17a2.47 2.47 0 0 0 2.5-2.49V12.85 5.22z",
        },
      },
      {
        type: "path",
        data: {
          d: "M7.36 12.1H4.19V8.93h3.17zm-2.77-.4H7V9.33H4.59zM9.18 10.32h8.96v.4H9.18zM7.36 17.15H4.19V14h3.17zm-2.77-.4H7v-2.38H4.59zM9.18 15.36h8.96v.4H9.18zM7.36 22.19H4.19V19h3.17zm-2.77-.4H7v-2.38H4.59zM9.18 20.4h8.96v.4H9.18z",
        },
      },
    ],
  },
  {
    name: "informes",
    viewBox: "0 0 22 21.96",
    elements: [
      {
        type: "path",
        data: {
          d: "M12 11.73l4.36 8.85A11 11 0 0 0 22 11.73zm5 6.62l-2.5-5.09h5.79A9.37 9.37 0 0 1 17 18.35zm0 0",
        },
      },
      {
        type: "path",
        data: {
          d: "M10.27 0a11 11 0 1 0 4.66 21.22l-4.67-9.49V0zm0 0",
        },
      },
      {
        type: "path",
        data: {
          d: "M11.79 0v10.2H22A11 11 0 0 0 11.79 0zm1.45 1.72c2.91.31 7 3.19 7.23 7.14h-7.23z",
        },
      },
    ],
  },
  {
    name: "configuracion",
    viewBox: "0 0 28.13 35.14",
    elements: [
      {
        type: "path",
        data: {
          d: "M15.23 0l1 .23a6.5 6.5 0 0 1 5.33 5.9 14.17 14.17 0 0 1-2.12 9.65A6.27 6.27 0 0 1 11.19 18a7.11 7.11 0 0 1-2.5-2.28 14 14 0 0 1-2-10.36 6.47 6.47 0 0 1 5.7-5.21 3.63 3.63 0 0 0 .54-.15z",
        },
      },
      {
        type: "path",
        data: {
          d: "M28.05 30.4c-.33-2.49-.69-5-1.2-7.42a5 5 0 0 0-3.76-3.93c-1-.29-2-.71-3.05-1.1a7.85 7.85 0 0 1-6 2.57 7.85 7.85 0 0 1-6-2.57c-1.06.39-2 .81-3 1.1A5 5 0 0 0 1.28 23c-.51 2.43-.87 4.91-1.2 7.4-.24 1.77 0 2 1.69 2.62a41.87 41.87 0 0 0 11.14 2.1H15.22A41.87 41.87 0 0 0 26.36 33c1.7-.56 1.93-.83 1.69-2.6z",
        },
      },
    ],
  },
  {
    name: "herramientas",
    viewBox: "0 0 24 24.95",
    elements: [
      {
        type: "path",
        data: {
          d: "M14.76 11.25l-1.5 1.5L9 17.06a.13.13 0 0 0 0 .19 4.51 4.51 0 0 1 .64 2.84 4.67 4.67 0 0 1-3.07 4.07 4.65 4.65 0 0 1-2.69.21l.06-.07 2.2-2.3a.41.41 0 0 0 .13-.28c0-.56.07-1.12.1-1.68l.09-1.45v-.61h-.33l-1.56.1-1.9.12a.27.27 0 0 0-.17.08l-2.27 2.3a.48.48 0 0 0-.09.11l-.06-.3a4.81 4.81 0 0 1 3.37-5.28 4.69 4.69 0 0 1 3.78.45h.17L13 9.84l.17-.16a3.27 3.27 0 0 1-.17-.31c-.12-.31-.24-.61-.35-.92s-.11-.23-.29-.23h-1.62c-.24 0-.32-.08-.32-.31V6.6c0-.2.08-.28.28-.28h1.7a.25.25 0 0 0 .29-.23 4.68 4.68 0 0 1 .49-1.18c.1-.17.09-.24 0-.38L12 3.36c-.17-.17-.17-.28 0-.44s.6-.62.91-.92a.25.25 0 0 1 .42 0l1.19 1.19a.24.24 0 0 0 .36.05 5 5 0 0 1 1.22-.5c.15 0 .2-.12.21-.29V.83a.4.4 0 0 1 0-.11.23.23 0 0 1 .25-.25h1.34a.23.23 0 0 1 .26.26v1.69c0 .21.05.28.25.33a4.61 4.61 0 0 1 1.17.49.25.25 0 0 0 .42-.05L21.14 2a.25.25 0 0 1 .4 0c.32.32.64.63.95 1a.23.23 0 0 1 0 .38l-1.17 1.13c-.16.16-.18.23-.07.42a4.37 4.37 0 0 1 .48 1.16c.05.17.11.23.29.23h1.69c.21 0 .29.08.29.29v1.32c0 .2-.08.29-.28.29H22c-.19 0-.25 0-.3.22a4.71 4.71 0 0 1-.51 1.23.24.24 0 0 0 .05.32c.4.39.8.79 1.19 1.19.17.17.18.26 0 .44l-.93.93a.24.24 0 0 1-.39 0L20 11.36c-.15-.15-.22-.16-.41 0a4.83 4.83 0 0 1-1.15.48c-.19 0-.24.11-.24.31v1.69a.24.24 0 0 1-.27.27h-1.39c-.19 0-.27-.08-.27-.27v-1.66c0-.24-.05-.29-.28-.35a4.65 4.65 0 0 1-1.11-.46zM17.22 10a2.71 2.71 0 1 0-2.71-2.73A2.7 2.7 0 0 0 17.22 10z",
        },
      },
      {
        type: "path",
        data: {
          d: "M17.21 8.55a1.29 1.29 0 1 1 1.29-1.29 1.28 1.28 0 0 1-1.29 1.29z",
        },
      },
    ],
  },
  {
    name: "tareas",
    viewBox: "0 0 22 24.95",
    elements: [
      {
        type: "path",
        data: {
          d: "M3.63 3.29v3.23a1.32 1.32 0 0 0 1.15 1.42 6.53 6.53 0 0 0 1.82 0 1.28 1.28 0 0 0 1.06-1.37V3.29H14c.27 0 .34.08.34.34v2.85A1.39 1.39 0 0 0 15.74 8 8.42 8.42 0 0 0 17 8a1.41 1.41 0 0 0 1.39-1.52V3.3h2.46c.78 0 1.08.3 1.08 1.09v18.22c0 .79-.23 1-1 1.1a4.35 4.35 0 0 1-.51 0H.91a.66.66 0 0 1-.75-.59 2 2 0 0 1 0-.48V4.35c0-.79.3-1.08 1.09-1.08zM11 10.73H1.73c-.47 0-.51 0-.51.49v11.14c0 .44 0 .47.48.47h7.39a1 1 0 0 0 .66-.23A23.62 23.62 0 0 0 13 19.82a6 6 0 0 0 1.86-3.4c.13-1.21.83-1.53 1.91-1 .66.35 1.28.79 1.92 1.21a1 1 0 0 0 1.45-.2 3.13 3.13 0 0 0 .7-1.88v-3.32c0-.45-.05-.5-.51-.5zm1.74 11.81v.09h7c.74 0 .94-.21.94-.94v-4.17-.35a40.8 40.8 0 0 1-7.94 5.37z",
        },
      },
      {
        type: "path",
        data: {
          d: "M6.84 4v2a.58.58 0 0 1-.62.65 11.41 11.41 0 0 1-1.17 0A.54.54 0 0 1 4.46 6V1.8A.51.51 0 0 1 5 1.25a9.69 9.69 0 0 1 1.32 0 .54.54 0 0 1 .54.6zM15.16 3.9v-2c0-.45.19-.67.64-.69a9.14 9.14 0 0 1 1.17 0 .53.53 0 0 1 .57.6v4.2a.55.55 0 0 1-.58.6h-1.2c-.41 0-.6-.25-.6-.67-.01-.66 0-1.35 0-2.04zM12.84 15.9H9.72v-3.14h3.12zM7.6 15.9H4.48v-3.13H7.6zM7.59 20.74h-3.1a2.13 2.13 0 0 1 0-.25v-2.64c0-.22.07-.29.29-.29h2.64c.14 0 .25 0 .25.2v2.88a.22.22 0 0 1-.08.1zM12.84 17.59a1.2 1.2 0 0 1-.27 1.14c-.63.61-1.22 1.27-1.83 1.89a.54.54 0 0 1-.32.13h-.7v-3.16zM17.93 12.76v1.89c-1-.53-2-1.25-3.15-.46v-1.43z",
        },
      },
    ],
  },
];

export const arrowIcon = {
  name: "arrow",
  viewBox: "0 0 448 512",
  elements: [
    {
      type: "path",
      data: {
        d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z",
      },
    },
  ],
};

export const marcaCsirtIcon = {
  name: "arrow",
  viewBox: "0 0 155.11 38.3",
  elements: [
    {
      type: "path",
      data: {
        d: "M149.21 33.34h-3l-5.85-26.71a16.57 16.57 0 0 1 3.57-.06c1.25 6 2.47 12 3.73 18h.15l3.73-18h3.57c-1.96 8.94-3.93 17.85-5.9 26.77zM64.27 28.82c.18.1.34.17.49.26a9.36 9.36 0 0 0 3.52 1.19 3.5 3.5 0 0 0 3.78-4.68A6.12 6.12 0 0 0 71 23.68a18.29 18.29 0 0 0-2.46-2.44c-1-.85-1.94-1.7-2.84-2.61a7.08 7.08 0 0 1-2-3.75 7.26 7.26 0 0 1 2-6.93 6.41 6.41 0 0 1 5.16-1.74 10.17 10.17 0 0 1 3.5.9.73.73 0 0 1 .51.79v2.95l-.54-.3a6.81 6.81 0 0 0-3.2-1.07 3.58 3.58 0 0 0-4 2.81A3.82 3.82 0 0 0 67.6 15a10.49 10.49 0 0 0 2.05 2.5c.61.55 1.26 1.08 1.9 1.6a15.22 15.22 0 0 1 2.83 2.9 7.9 7.9 0 0 1 1.38 5.75 6.57 6.57 0 0 1-2.37 4.46 6.63 6.63 0 0 1-4 1.54 9.23 9.23 0 0 1-4.77-1.12c-.22-.11-.39-.23-.38-.53v-3a1 1 0 0 1 .03-.28zM139 29.36a3.26 3.26 0 0 1 0 .34v2.7a.53.53 0 0 1-.35.55 8 8 0 0 1-4.51.69 6.81 6.81 0 0 1-5.68-4.54 17 17 0 0 1-1.18-4.8 32.65 32.65 0 0 1-.21-5.23 24.06 24.06 0 0 1 1.07-7 9.61 9.61 0 0 1 2.37-4 6.86 6.86 0 0 1 4.13-1.88 8.27 8.27 0 0 1 3.85.44c.5.18.5.19.5.7v2.86l-.69-.25a5.5 5.5 0 0 0-3.08-.33 4.31 4.31 0 0 0-3.11 2.23 9.61 9.61 0 0 0-1.1 3.33 32.09 32.09 0 0 0-.1 9.18A10.26 10.26 0 0 0 132 28a4.16 4.16 0 0 0 4.11 2.34 5.69 5.69 0 0 0 2.16-.61zM61.49 32.79a6.79 6.79 0 0 1-2.82.88 8.14 8.14 0 0 1-3.43-.35 6.42 6.42 0 0 1-3.37-2.63 12.15 12.15 0 0 1-1.7-4.34 32.76 32.76 0 0 1-.48-8.56 22.7 22.7 0 0 1 .92-5.42 11.16 11.16 0 0 1 1.59-3.25 6.89 6.89 0 0 1 5.06-2.88 8.39 8.39 0 0 1 3.79.45c.47.17.47.18.47.67v2.83l-.71-.26a5.59 5.59 0 0 0-3.13-.31 4.3 4.3 0 0 0-2.92 2A8.62 8.62 0 0 0 53.57 15a30.75 30.75 0 0 0 0 10 9 9 0 0 0 1 3 4.15 4.15 0 0 0 4 2.28 5.93 5.93 0 0 0 2.32-.65l.59-.28zM115.78 6.55v3.26h-4.91v23.52h-3.57V9.87h-4.95V6.55zM79.43 6.55h3.45v26.78h-3.45zM123.38 23v2.75a61.46 61.46 0 0 1-7.33 0V23zM95.22 20.22l.2-.11.48-.1a4.85 4.85 0 0 0 3.89-3.43 10.45 10.45 0 0 0 0-6.19 4.66 4.66 0 0 0-3.08-3.21 9 9 0 0 0-2.79-.57c-1.84-.06-3.68-.07-5.52-.09a3 3 0 0 0-.5 0v26.83h3.48V22.42a12.78 12.78 0 0 1 .11-2.13c.79 1.41 1.45 2.87 2.13 4.32S95 27.54 95.7 29l2 4.36h3.79zm-3.45-2a1.65 1.65 0 0 1-.34-.08V9.73c.07 0 .12-.08.17-.08.78 0 1.58 0 2.36.1a2.61 2.61 0 0 1 2.63 2.66 9.26 9.26 0 0 1-.12 3.19 2.92 2.92 0 0 1-2.78 2.55 17.51 17.51 0 0 1-1.92.09z",
      },
    },
    {
      type: "circle",
      data: {
        cx: "19.02",
        cy: "19.28",
        r: "6.22",
      },
    },
    {
      type: "path",
      data: {
        d: "M32.37 16.44a14 14 0 0 1 .3 2.84A13.63 13.63 0 1 1 24.87 7V1.18a19 19 0 1 0 13 15.26z",
      },
    },
    {
      type: "path",
      data: {
        d: "M41.37 2.4l-1.54 1.53-4.45 4.45-.7.71c-.12.12-.08.22.09.22h3.36v3.39h-9.62V3.08h3.39v3.67c0 .18.1.22.23.09l1-1L39 0z",
      },
    },
  ],
};

export const descargarIcon = {
  name: "descargar",
  viewBox: "0 0 14.47 14.4",
  elements: [
    {
      type: "path",
      data: {
        d: "M7.23 9c.1 0 .2-.13.34-.3.87-1.1 2.74-3.4 2.83-3.56H8.6C8.59 5 8.6 0 8.6 0H5.87v5.14h-1.8C4.16 5.3 6 7.6 6.9 8.66c.1.17.23.34.33.34zM12.27 9.2v3.25H2.2V9.2H.28v4c0 .71.06 1.19.77 1.19h12.36c.72 0 .78-.48.78-1.19v-4z",
      },
    },
  ],
};

export const editarIcon = {
  name: "editar",
  viewBox: "0 0 14.47 14.4",
  elements: [
    {
      type: "path",
      data: {
        d: "M9 2.4l2.94 2.95-7.45 7.45-2.94-3zm5.17-.71L12.86.38a1.3 1.3 0 0 0-1.86 0L9.76 1.64l3 2.94 1.46-1.47a1 1 0 0 0 0-1.42zM0 14a.33.33 0 0 0 .4.4l3.28-.8-2.93-2.95zm0 0",
      },
    },
  ],
};

export const eliminarIcon = {
  name: "eliminar",
  viewBox: "0 0 14.47 14.4",
  elements: [
    {
      type: "path",
      data: {
        d: "M12.92 13.44a.73.73 0 0 1 .12.34.28.28 0 0 1-.14.23 1 1 0 0 1-.42.12 6.78 6.78 0 0 1-.73 0 6.21 6.21 0 0 1-.69 0 1.31 1.31 0 0 1-.4-.07.47.47 0 0 1-.23-.13.62.62 0 0 1-.14-.18L7.16 8.59 4 13.76a.59.59 0 0 1-.13.18.52.52 0 0 1-.23.13 1.44 1.44 0 0 1-.4.07 5.74 5.74 0 0 1-.66 0 5.92 5.92 0 0 1-.68 0 .81.81 0 0 1-.35-.14.26.26 0 0 1-.12-.23.7.7 0 0 1 .14-.34l4.05-6.35L1.78 1a1.07 1.07 0 0 1-.12-.38.28.28 0 0 1 .13-.24 1 1 0 0 1 .42-.12A7.48 7.48 0 0 1 3 .23h.67A2.47 2.47 0 0 1 4 .32a.64.64 0 0 1 .22.11.83.83 0 0 1 .13.18l3 4.85 3-4.85a1 1 0 0 1 .13-.16.48.48 0 0 1 .2-.12A1.13 1.13 0 0 1 11 .25h.62a6.47 6.47 0 0 1 .69 0 1.07 1.07 0 0 1 .4.11.22.22 0 0 1 .11.22 1.08 1.08 0 0 1-.14.37L8.9 7z",
      },
    },
  ],
};

export const verIcon = {
  name: "ver",
  viewBox: "0 0 14.47 14.4",
  elements: [
    {
      type: "path",
      data: {
        d: "M14.05 12.18l-2.57-2.57a5.58 5.58 0 0 1-.82 1 6 6 0 0 1-1 .82L12.21 14a1.3 1.3 0 0 0 1.84-1.84zm0 0M10.26 1.75a6 6 0 1 0 0 8.47 6 6 0 0 0 0-8.47zM2.89 9.12a4.43 4.43 0 1 1 6.27 0 4.44 4.44 0 0 1-6.27 0zm0 0",
      },
    },
    {
      type: "path",
      data: {
        d: "M4.12 6.47C4 6 3.47 5.22 3 5.45s-.25 1-.09 1.48c.74 2.2 3.41 2.66 3.69 2.38s-2-.78-2.51-2.84zm0 0",
      },
    },
  ],
};

export const newTestIcon = {
  name: "newTest",
  viewBox: "0 0 35.79 40.71",
  elements: [
    {
      type: "path",
      data: {
        d: "M35.63 31.34a7.81 7.81 0 1 0-13.22 7 9.39 9.39 0 0 0 4.43 2.34H29a1.74 1.74 0 0 1 .41-.16 7.81 7.81 0 0 0 6.22-9.18zm-4.48 2.89h-1.8v1.92a1.38 1.38 0 0 1-1.43 1.49c-.77 0-1.24-.59-1.26-1.53V34.4l-.13-.17h-1.78c-.92 0-1.47-.5-1.49-1.31s.53-1.36 1.51-1.39h1.9v-1.9A1.35 1.35 0 0 1 28 28.12a1.39 1.39 0 0 1 1.39 1.46v2h1.77c1 0 1.66.56 1.65 1.39s-.69 1.25-1.66 1.26zM8.44 6.58h12.2a.92.92 0 0 0 1-1V3.42a.91.91 0 0 0-1-1h-1.26a.53.53 0 0 1-.57-.34c-.28-.52-.61-1-.89-1.55a.89.89 0 0 0-.87-.53h-4.51c-1.51 0-1.32-.23-2 1.17a1.85 1.85 0 0 1-2.17 1.26c-.67-.09-1 .36-1 1v2c-.04.82.29 1.15 1.07 1.15zM23 5.67h2.44c.81 0 1.26.33 1.26 1.25v16.74a7.9 7.9 0 0 1 2.06 0h.2v-6.74-10a3.37 3.37 0 0 0-3.49-3.46h-2.82v2c.04.07.24.2.35.21z",
      },
    },
    {
      type: "path",
      data: {
        d: "M18.73 33.64H3.55c-.95 0-1.27-.33-1.27-1.27v-4.78V6.92c0-.93.31-1.24 1.24-1.24h2.45c.11 0 .32-.14.32-.22v-2H3.46A3.36 3.36 0 0 0 0 6.87c.06 3.35 0 6.7 0 10.05v15.69a3.24 3.24 0 0 0 3.27 3.28h15.95a9.93 9.93 0 0 1-.49-2.25z",
      },
    },
    {
      type: "path",
      data: {
        d: "M9.7 15.94H5.52v-4.18H9.7zm-3.65-.53h3.12v-3.12H6.05zM12.09 13.59h11.8v.53h-11.8zM9.7 22.58H5.52V18.4H9.7zm-3.65-.52h3.12v-3.13H6.05zM12.09 20.23h11.8v.53h-11.8zM9.7 29.22H5.52v-4.17H9.7zm-3.65-.52h3.12v-3.13H6.05zM20.93 26.87h-8.84v.53h8.42c.13-.18.28-.4.42-.53z",
      },
    },
  ],
};
export const tareasIcon = {
  name: "tareas",
  viewBox: "0 0 22 24.95",
  elements: [
    {
      type: "path",
      data: {
        d: "M3.63 3.29v3.23a1.32 1.32 0 0 0 1.15 1.42 6.53 6.53 0 0 0 1.82 0 1.28 1.28 0 0 0 1.06-1.37V3.29H14c.27 0 .34.08.34.34v2.85A1.39 1.39 0 0 0 15.74 8 8.42 8.42 0 0 0 17 8a1.41 1.41 0 0 0 1.39-1.52V3.3h2.46c.78 0 1.08.3 1.08 1.09v18.22c0 .79-.23 1-1 1.1a4.35 4.35 0 0 1-.51 0H.91a.66.66 0 0 1-.75-.59 2 2 0 0 1 0-.48V4.35c0-.79.3-1.08 1.09-1.08zM11 10.73H1.73c-.47 0-.51 0-.51.49v11.14c0 .44 0 .47.48.47h7.39a1 1 0 0 0 .66-.23A23.62 23.62 0 0 0 13 19.82a6 6 0 0 0 1.86-3.4c.13-1.21.83-1.53 1.91-1 .66.35 1.28.79 1.92 1.21a1 1 0 0 0 1.45-.2 3.13 3.13 0 0 0 .7-1.88v-3.32c0-.45-.05-.5-.51-.5zm1.74 11.81v.09h7c.74 0 .94-.21.94-.94v-4.17-.35a40.8 40.8 0 0 1-7.94 5.37z",
      },
    },
    {
      type: "path",
      data: {
        d: "M6.84 4v2a.58.58 0 0 1-.62.65 11.41 11.41 0 0 1-1.17 0A.54.54 0 0 1 4.46 6V1.8A.51.51 0 0 1 5 1.25a9.69 9.69 0 0 1 1.32 0 .54.54 0 0 1 .54.6zM15.16 3.9v-2c0-.45.19-.67.64-.69a9.14 9.14 0 0 1 1.17 0 .53.53 0 0 1 .57.6v4.2a.55.55 0 0 1-.58.6h-1.2c-.41 0-.6-.25-.6-.67-.01-.66 0-1.35 0-2.04zM12.84 15.9H9.72v-3.14h3.12zM7.6 15.9H4.48v-3.13H7.6zM7.59 20.74h-3.1a2.13 2.13 0 0 1 0-.25v-2.64c0-.22.07-.29.29-.29h2.64c.14 0 .25 0 .25.2v2.88a.22.22 0 0 1-.08.1zM12.84 17.59a1.2 1.2 0 0 1-.27 1.14c-.63.61-1.22 1.27-1.83 1.89a.54.54 0 0 1-.32.13h-.7v-3.16zM17.93 12.76v1.89c-1-.53-2-1.25-3.15-.46v-1.43z",
      },
    },
  ],
};
export const logoutIcon = {
  name: "logoutIcon",
  viewBox: "0 0 22 24.01",
  elements: [
    {
      type: "path",
      data: {
        d: "M10.91 24a11 11 0 01-9.75-6.23A11.08 11.08 0 010 12.23 11.23 11.23 0 014.05 4a5.45 5.45 0 01.47-.37 1.43 1.43 0 011.66-.05 1.51 1.51 0 01.76 1.55 1.58 1.58 0 01-.64 1.12 7.7 7.7 0 00-3 5 8.06 8.06 0 005.16 9.07 7.39 7.39 0 007.42-1.27 7.71 7.71 0 003-5.54 7.85 7.85 0 00-3.3-7.4 1.63 1.63 0 01.09-2.72 1.49 1.49 0 011.74.11 11.45 11.45 0 013.25 3.74 11.18 11.18 0 011.38 6 11.29 11.29 0 01-7.51 10.16 10.68 10.68 0 01-3.62.6z",
      },
    },
    {
      type: "path",
      data: {
        d: "M9.43 6.41V1.68a1.62 1.62 0 01.76-1.44 1.55 1.55 0 012.32 1 1.91 1.91 0 01.05.48v9.43a1.62 1.62 0 01-1.14 1.6 1.56 1.56 0 01-2-1.34v-.32z",
      },
    },
  ],
};
export const plusIcon = {
  name: "plusIcon",
  viewBox: "0 0 15.32 15.32",
  elements: [
    {
      type: "path",
      data: {
        d: "M7.66 0a7.66 7.66 0 107.66 7.66A7.66 7.66 0 007.66 0zm4 8.69h-3v3h-2v-3h-3V6.63h3v-3h2v3h3z",
      },
    },
  ],
};
